import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function page1({ getReport }) {

  return (
    <View style={styles.back}>
      <FlatList
        data={getReport}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          return (
            <View>
              {index == 0 && (
                <View style={[styles.head, { height: 50 }]}>
                  <View style={[styles.viewhead, { width: width * 0.07 }]}>
                    <Text style={styles.textadd}>ลำดับ</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.32 }]}>
                    <Text style={styles.textadd}>
                      ชื่อ/ที่อยู่ในการออกใบเสร็จรับเงิน
                    </Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.25 }]}>
                    <Text style={styles.textadd}>รายการ</Text>
                  </View>
                  <View style={[styles.viewheadent, { width: width * 0.18 }]}>
                    <Text style={styles.textadd}>ราคา</Text>
                  </View>
                </View>
              )}

              <View
                style={[
                  styles.head,
                  { borderTopColor: "#fff" },
                  { backgroundColor: "#fff" },
                ]}
              >
                <View style={[styles.viewhead, { width: width * 0.07 }]}>
                  <Text style={styles.textadd}>{index + 1}</Text>
                </View>
                <View style={[styles.viewhead, { width: width * 0.32 }]}>
                  <Text style={styles.textadd}>
                    <Text style={styles.textadd}>
                      {item?.fullAddress_vat?.text +
                        " " +
                        item?.fullAddress_vat?.ShippingAddress +
                        " " +
                        item?.fullAddress_vat?.district +
                        " " +
                        item?.fullAddress_vat?.postcode +
                        " " +
                        item?.fullAddress_vat?.province +
                        " " +
                        item?.fullAddress_vat?.subDistrict +
                        " " +
                        (item?.fullAddress_vat?.telnum || "")}
                      {"\n"}
                      {item.text7}
                    </Text>
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <View style={[styles.viewhead, { width: width * 0.25 }]}>
                    <View style={styles.viewlow}>
                      <Text style={styles.textadd}>วิ่ง</Text>
                      <Text style={styles.textadd}>{item.event_name}</Text>
                    </View>
                    <View style={styles.viewlow}>
                      <Text style={styles.textadd}>บิ๊บ</Text>
                      <Text style={styles.textadd}>{item.bib}</Text>
                    </View>
                    <View style={styles.viewlow}>
                      <Text style={styles.textadd}>อื่นๆ</Text>
                      <Text style={styles.textadd}>
                        {item?.fullAddress?.name}
                      </Text>
                    </View>
                    <View style={styles.viewlow}>
                      <Text style={styles.textadd}>ค่าจัดส่ง</Text>
                      <Text style={styles.textadd}>{item.text9}</Text>
                    </View>
                    <View style={styles.viewlowent}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>ราคาก่อนVat</Text>
                    </View>
                    <View style={styles.viewlowent}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>Vat%</Text>
                    </View>
                    <View style={styles.viewlowent}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>รวมชำระ</Text>
                    </View>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.1829 }]}>
                    <View style={styles.viewee}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>{item.pay_status}</Text>
                    </View>
                    <View style={styles.viewee}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>
                        {!item.VIP_Status ? "ฟรี" : 35}
                      </Text>
                    </View>
                    <View style={styles.viewee}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}></Text>
                    </View>
                    <View style={styles.viewee}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>
                        {item?.event_Listt?.distance?.[0].cost}
                      </Text>
                    </View>
                    <View style={styles.vieweent}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>
                        {parseInt(item.pay_status) +
                          (item.VIP_Status ? 35 : 0) * 0.93}
                      </Text>
                    </View>
                    <View style={styles.viewee}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>
                        {parseInt(item.pay_status) +
                          (item.VIP_Status ? 35 : 0) * 0.07}
                      </Text>
                    </View>
                    <View style={styles.vieweent}>
                      <Text style={styles.textadd}>{""}</Text>
                      <Text style={styles.textadd}>
                        {parseInt(
                          parseInt(item.pay_status) +
                          (item.VIP_Status ? 35 : 0) -
                          (parseInt(item.pay_status) +
                            (item.VIP_Status ? 35 : 0)) *
                          0.07
                        )}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          );
        }}
      />
      {/* <View style={styles.viewatc}>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-left"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.touchatc, { backgroundColor: "#FCC81D" }]}
        >
          <Text style={styles.textatc}>1</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>2</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>3</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>4</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-right"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
      </View> */}
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.825,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    zIndex: -99,
  },
  head: {
    width: width * 0.8224,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderWidth: 0.5,
    borderColor: "#666666",
  },
  detail: {
    width: width * 0.825,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#666666",
  },
  viewhead: {
    borderRightWidth: 0.5,
    borderColor: "#666666",
    justifyContent: "center",
    paddingHorizontal: 10,
  },
  viewheadent: {
    justifyContent: "center",
  },
  viewlow: {
    flexDirection: "row",
    width: width * 0.248,
    justifyContent: "space-between",
    alignSelf: "center",
    borderBottomWidth: 0.5,
    borderColor: "#666666",
    height: 50,
    paddingHorizontal: 10,
  },

  viewlowent: {
    flexDirection: "row",
    width: width * 0.248,
    justifyContent: "space-between",
    alignSelf: "center",
    height: 50,
    paddingHorizontal: 10,
  },
  viewee: {
    flexDirection: "row",
    width: width * 0.1823,
    borderBottomWidth: 0.5,
    borderColor: "#666666",
    height: 50,
    paddingHorizontal: 10,
    justifyContent: "space-between",
    alignSelf: "center",
  },
  vieweent: {
    flexDirection: "row",
    width: width * 0.182,
    justifyContent: "space-between",
    alignSelf: "center",
    height: 50,
    paddingHorizontal: 10,
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginVertical: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    alignSelf: "center",
  },
  input: {
    width: width * 0.1,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#666666",
    paddingLeft: 20,
    alignSelf: "center",
  },
  touctto: {
    width: width * 0.1,
    height: 30,
    backgroundColor: "#4B4B48",
    borderRadius: 5,
    justifyContent: "center",
    alignSelf: "center",
  },
});
